export function getPauseMessageFromUTC({
  daysOff,
}: {
  daysOff: string[];
}): string {
  const formattedDays =
    daysOff.length === 1
      ? daysOff[0]
      : daysOff.slice(0, -1).join(", ") + " and " + daysOff.slice(-1);

  return `Notifications are paused on ${formattedDays}`;
}
